<template>
  <div style="margin-bottom: 100px;">
    <el-row style="height: 40px;">
      <el-col>
        <el-checkbox v-model="span" size="mini" >导入时合并</el-checkbox>
        <el-upload style="display: inline-block"
                   class="upload-demo"
                   action="#"
                   :auto-upload="false"
                   :show-file-list="false"
                   accept="application/msexcel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                   :on-change="upLoadExcel">
          <el-button size="mini" type="success">导入外部订单</el-button>
        </el-upload>
        <el-button type="primary" size="mini" @click="openSingle">手工录入</el-button>
        <el-link href="./static/template/free.xls"  type="primary"  style="margin-left: 2px; font-size: 12px">模板下载</el-link>

        <el-select v-show="false" id="printStatus" v-model="printStatus" size="small" style="width: 150px; margin-left: 10px;" placeholder="请选择" @change="getFreeData">
          <el-option  v-for="item in statusList" :key="item.value" :label="item.title" :value="item.value"> </el-option>
        </el-select>
        <el-input v-model="tid" size="mini" style="width: 180px; margin-left: 20px" clearable placeholder="订单号"></el-input>
        <el-input v-model="waybillNo" size="mini" style="width: 160px" clearable placeholder="快递单号"></el-input>

        <el-cascader style="width:160px" @change="getCity" size="mini" v-show="false"
          placeholder="地址区域"
          v-model="regionList" ref="cascader"
          :options="cities"
          :props="{ multiple: true ,emitPath: false, checkStrictly: false}"
          :key="regionKeys" :show-all-levels="false"
           clearable collapse-tags>
        </el-cascader>
        <el-button type="primary" size="mini"  style="margin-left: 5px" @click="getFreeData">搜索订单</el-button>

      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>

      </el-col>
    </el-row>

    <el-row style="">
      <el-col>
        <span style="font-size: 10pt">快递单模板：</span>
        <span v-show="kdmbs.length == 0" style="font-size: 12px;font-weight: bold;color: darkorange;">未设置</span>
        <el-radio-group v-model="kdmb" @change="changeKdmb">
          <el-radio v-for="opt in kdmbs" :key="opt.id" :label="opt.id">{{opt.tempName}}</el-radio>
        </el-radio-group>
        <el-select v-model="sfProduct" size="mini" style="width: 80px;margin-left: 20px;" placeholder="请选择">
          <el-option  v-for="item in sfProducts" :key="item.value"  :label="item.label"  :value="item.value">  </el-option>
        </el-select>
        <el-button  plain type="primary" size="mini" @click="addTemp" style="margin-left: 20px;">添加模板</el-button>
        <span style="font-size: 10pt;margin-left: 30px">共有 </span>
        <span style="font-size: 18px;color: darkorange; font-weight: bold">{{pageObject.rowCount}}</span>
        <span style="font-size: 10pt"> 个包裹</span>
      </el-col>
    </el-row>

    <el-row style="margin-top: 10px">
      <el-col>
        <el-tabs v-model="printStatus" @tab-click="getFreeData">
          <el-tab-pane label="未打印" name="WAIT_PRINT"></el-tab-pane>
          <el-tab-pane label="已打印未发货" name="PRINTED"></el-tab-pane>
          <el-tab-pane label="已发货" name="WAIT_CONFIRM"></el-tab-pane>
        </el-tabs>

        <el-table border :data="freeData" ref="multipleTable" style="font-size: 12px;" :cell-style="{padding: '0px'}" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  type="selection" width="40">
          </el-table-column>
          <el-table-column  label="ID" type="index" :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="140px"></el-table-column>
          <el-table-column  prop="name" label="姓名" width="80px"></el-table-column>
          <el-table-column  prop="mobile" label="手机" width="120px"></el-table-column>
          <el-table-column  prop="province" label="省份" width="60px" ></el-table-column>
          <el-table-column  prop="detail" label="地址" ></el-table-column>
          <el-table-column  prop="properties" label="物品信息" width="160px"></el-table-column>
          <el-table-column  prop="memo" label="备注" width="120px"></el-table-column>
          <el-table-column  prop="num" label="数量" width="60px"></el-table-column>
          <el-table-column  prop="waybillCode" label="快递单号" width="120px"></el-table-column>
          <el-table-column width="100px"  >
            <template slot-scope="scope">
              <div style="height: 40px; line-height: 40px; margin-left: 5px; vertical-align: middle; border: red 0px solid">
                <el-button v-show="printStatus=='WAIT_PRINT'" type="text" size="mini" @click="openTrade(scope.$index, scope.row)">修改</el-button>
                <el-button v-show="printStatus=='WAIT_PRINT'" type="text" size="mini" @click="delTrade(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block" align="left" style="margin-left: 400px; color: #000">

      <span class="demonstration"></span>
      <el-pagination style="color: #000"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pageObject.pageCurrent"
                     :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                     :page-size="pageObject.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="pageObject.rowCount">
      </el-pagination>
    </div>

    <div style="text-align: center;padding: 10px 50px; position: fixed; left: 200px; right: 0; bottom: 0; z-index: 5;border-top: #cccccc solid 2px; background-color: #ffffff">

      <el-button type="primary" v-show="printStatus=='WAIT_PRINT'"  style="display: inline" @click="getPrintTids('print')">打印快递单</el-button>
      <el-button type="danger" plain v-show="printStatus=='WAIT_PRINT'"  style="display: inline;margin-left: 50px;" @click="batDelTrade('')">批量删除</el-button>
      <el-button type="primary"  v-show="printStatus != 'WAIT_PRINT'" style="display: inline" @click="getPrintTids('preview')">预览</el-button>
      <el-button type="primary"  v-show="printStatus != 'WAIT_PRINT'" style="display: inline" @click="getPrintTids('rePrint')">重打快递单</el-button>
      <el-button type="primary" v-show="printStatus != 'WAIT_PRINT'"  style="display: inline" @click="getPrintTids('cancel')">取消面单号</el-button>
      <el-button type="primary" v-show="printStatus=='PRINTED'"  style="display: inline" @click="getPrintTids('sendGoods')">发货</el-button>
    </div>

    <el-dialog
      title="打印预览" :close-on-click-modal="false"
      :visible.sync="showPreview"
      width="400px"
      center>
      <img width="350px" height="600px" :src="this.imgUrl"/>
      <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="showPreview=false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改订单" :close-on-click-modal="false"
      :visible.sync="showTid"
      width="500px"
      center>

      <span style="display:inline-block; line-height: 120px; " >物品：</span> <el-input :rows="5" type="textarea" v-model="properties"  style="width: 400px"> </el-input>
      <span >数量：</span><el-input-number size="medium" v-model="num"  :min="1" style="margin-top: 15px;width: 400px"></el-input-number>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTid = false">取 消</el-button>
        <el-button type="primary" @click="updateTrade">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="手工录入订单" :close-on-click-modal="false"
      :visible.sync="showSingle"
      width="600px"
      center>

        <el-row>
          <span class="label" ><span class="must">*</span>地址信息：</span>
          <el-cascader :key=key v-model="code"  :options="cities" placeholder="请选择省 / 市 / 区" style="width:400px"  @change="handleChange"></el-cascader>
        </el-row>
        <el-row style="margin-top: 5px;">
          <span class="mltlabel"><span class="must">*</span>详细地址：</span>
          <el-input v-model="detail" :rows="2" type="textarea" size="mini" style="width:400px" minlength="5"  placeholder="详细地址"></el-input>
        </el-row>
      <el-row style="margin-top: 5px;">
        <span class="label"><span class="must">*</span>姓名：</span>
        <el-input v-model="name" size="small" style="width:140px"  placeholder="收件人"></el-input>
        <span style="margin-left: 30px"><span class="must">*</span>手机：</span>
        <el-input v-model="mobile" size="small" style="width:170px"  placeholder="11位手机号"></el-input>
      </el-row>

      <el-row style="margin-top: 5px;">
        <span class="mltlabel" style=" " >智能识别地址：</span> <el-input :rows="2" type="textarea" size="mini"
               placeholder="粘贴地址，自动识别，识别后请检查是否正确"  v-model="smartAddr"  style="width: 400px" @change="autoAddr" @input="autoAddr"> </el-input>
      </el-row>
      <el-row style="margin-top: 5px;">
        <span class="mltlabel" style="" >物品：</span> <el-input :rows="2" type="textarea" size="mini"  v-model="properties"  style="width: 200px"> </el-input>
        <span style="margin-left: 5px">数量：</span><el-input-number  v-model="num"  :min="1" style="margin-top: 15px;width: 130px"></el-input-number>
      </el-row>

      <el-row style="margin-top:5px;">
        <span class="mltlabel" >备注：</span> <el-input :rows="2" type="textarea" size="mini"  v-model="memo"  style="width: 400px"> </el-input>
      </el-row>

      <el-row style="margin-top:5px;">
        <span class="mltlabel" >关联淘宝订单：</span> <el-input  type="text" size="mini"  v-model="sendTids"  style="width: 400px"> </el-input>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSingle = false">取 消</el-button>
        <el-button type="primary" @click="addSingle">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示" :close-on-click-modal="false"
      :visible.sync="showMsg"
      width="500px"
      center>
      <div style="font-size: 14px">{{msg}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showMsg=false">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import storage from "../api/storage";
  import $api from "../api/axios";
  import smart from 'address-smart-parse'

    export default {
      name: "Free",
      data(){
        return{
          key:0,
          code: [],
          cities:[],
          regionList:[],
          regionKeys:'',
            province: "",
            city: "",
            country: "",
            name:'',
            mobile:'',
            memo:'',
            sendTids:'',
            detail:'',
            smartAddr:'',
          serialNo:'',
          tid:'',
          waybillNo:'',
          kdmb:'',
          kdmbs:[],
          imgUrl:'',
          showPreview:false,
          showTid: false,
          properties:'',
          num:'',
          index:'',
          //手工订单
          showSingle:false,
          //合并订单
          span:true,
          //顺丰产品
          sfProduct:'323',
          sfProducts:[{value:'323', label:'微小件'},{value:'111', label:'干配'},{value:'2', label:'标快'},{value:'1', label:'特快'}],
          showMsg: false,
          msg:'',
          freeData:[],
          printStatus:'WAIT_PRINT',
          statusList:[{title:'未打印',value:'WAIT_PRINT'},{title:'已打印未发货',value:'PRINTED'},{title:'已发货',value:'WAIT_CONFIRM'}],
          cities:[],
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 10
          },

        }
      },
      computed:{
        fullAddress:function(){
          return this.selected.province +"-"+ this.selected.city +"-"+ this.selected.area
        }
      },
      methods:{
        //https://www.cnblogs.com/cangqinglang/p/11627496.html
        //https://blog.csdn.net/weixin_45693257/article/details/107822381
        //https://blog.csdn.net/weixin_43412413/article/details/124489000
        autoAddr(){
          const addr = smart(this.smartAddr);
          this.name = addr.name;
          this.mobile = addr.phone;
          if (addr.street != undefined)
            this.detail = addr.street + addr.address;
          else
            this.detail = addr.address;
          this.code[0] = addr.provinceCode + '0000';
          this.code[1] = addr.cityCode + '00';
          this.code[2] =  addr.countyCode;
          this.province = addr.province;
          this.city = addr.city;
          this.country = addr.county;
          this.detail = addr.address;
          this.key++;
          console.log(this.code);
          console.log(address);
        },
        init(){
          this.$axios.get('/static/js/citys.json').then(res => {
            this.cities = res.data;
          })
        },
        indexMethod(index)
        {
          return index + 1;
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getFreeData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getFreeData();
        },
        getFreeData(){
          let param={
            nick: storage.get('nick'),
            tid:this.tid,
            waybillNo: this.waybillNo,
            printStatus: this.printStatus,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/free/getTrade", param, response=>{
            let dataResult = response.data;
            console.log( dataResult);
            if(dataResult.state == 1){
              this.freeData = dataResult.data.free;
              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }
          })
        },
        delTrade(row){
          this.$confirm("确认删除该订单么？", "删除", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            let param = {
              nick: storage.get('nick'),
              id: row.id
            }
            $api.post("/free/delTrade", param, response => {
              let dataResult = response.data;
              if (dataResult.state == 1) {
                this.getFreeData();
                this.$message.warning("删除成功!");

              } else {
                this.$message.error(dataResult.data);
              }
            })
          })
        },
        batDelTrade(){
          let oids='';
          const selectData = this.$refs.multipleTable.selection;
          if(selectData.length == 0){
            this.$message.error("您没有勾选任何订单，请选择订单");
            return;
          }
          this.$confirm("确认删除选中的订单么？", "批量删除", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            for(let i=0;i<selectData.length;i++){
              oids = oids + selectData[i].serialNo+",";
            }
            let param = {
              nick: storage.get('nick'),
              oids: oids
            }
            $api.post("/free/batDelTrade", param, response => {
              let dataResult = response.data;
              if (dataResult.state == 1) {
                this.getFreeData();
                this.$message.warning("删除成功!");

              } else {
                this.$message.error(dataResult.data);
              }
            })
          })
        },
        openTrade(index, row){
          this.serialNo = row.serialNo
          this.properties = row.properties;
          this.num = row.num
          this.index = index;
          this.showTid = true;
        },
        updateTrade(row){
          let param={
            serialNo: this.serialNo,
            properties: this.properties,
            num: this.num,
          }
          $api.post("/free/updateTrade", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.freeData[this.index].properties =  this.properties;
              this.freeData[this.index].num =  this.num;
              this.showTid = false;
              this.$message.warning("修改订单信息成功!");
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        openSingle(){
          this.code = [];
          this.province = '';
          this.city = '';
          this.country = '';
          this.detail = '';
          this.smartAddr = '';
          this.name = '';
          this.mobile = '';
          this.properties = '';
          this.num = 1;
          this.memo = '';
          this.showSingle = true;
        },
        addSingle(){
          if(this.code.length == 0){
            this.$message.error("请选择所在地区！");
            return;
          }
          if(this.detail.length < 5){
            this.$message.error("详细地址不能少于5个字！");
            return;
          }
          if(this.name.length == 0){
            this.$message.error("请输入收件人姓名！");
            return;
          }
          if(this.mobile.length < 11){
            this.$message.error("手机号不能小于11位！");
            return;
          }
          /*const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          if(!reg.test(this.mobile)){
            this.$message.error("手机号格式不正确！");
            return;
          }*/
          console.log(this.country);
          let param = {
            nick: storage.get('nick'),
            province: this.province,
            city: this.city,
            country: this.country,
            detail: this.detail,
            name : this.name,
            mobile: this.mobile,
            properties: this.properties,
            num: this.num,
            memo: this.memo,
            sendTids: this.sendTids,
          }
          $api.post("/free/addSingle", param, response=>{
              let dataResult = response.data;
              if(dataResult.state == 1){
                this.showSingle = false;
                this.getFreeData();
                this.$message.success('录入订单成功！');
              }else{
                this.$message.error(dataResult.data);
              }
            })
        },
        //打开添加模板页
        addTemp:function(){
          this.$router.push({name: 'KddTemp'});
        },
        //获取用户模板
        getTemp: function(){
          let param ={
            nick:storage.get('nick'),
            tempName:'',
            compName:'',
          }
          $api.post("/setup/getTemp", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.kdmbs = dataResult.data;
              if(this.kdmbs.length>0){
                this.kdmb = this.kdmbs[0].id;
                this.printer = this.kdmbs[0].printer;
              }
            }
          })
        },
        //切换模板时取用户模板ID和打印机
        changeKdmb(){
          for(let i=0;i<this.kdmbs.length;i++){
            if(this.kdmbs[i].id ==  this.kdmb){
              this.printer =  this.kdmbs[i].printer;
            }
          }
        },
        upLoadExcel(file, fileList){
          // 文件上传前做一下判断
          // const type_ALLOWD = ['doc', 'docx', 'txt', 'xls', 'xlsx', 'text', 'pdf']
          const type_ALLOWD = ['xls', 'xlsx']
          const fileType = file.raw.name.substring(
            file.raw.name.lastIndexOf('.') + 1
          )
          // 判断文件格式
          if (type_ALLOWD.indexOf(fileType) === -1) {
            this.$message({
              showClose: true,
              message: "只能上传以'.xls'、 '.xlsx'结尾的文件,请重新上传！",
              type: 'error',
            });
          } else {
            let nick = storage.get('nick')
            let span = 'n';
            if(this.span)
              span = 'y';
            let formData = new FormData()
            formData.append('file', file.raw);
            $api.upload("/free/upload/" + nick + "/" + span, formData, response=>{
              let dataResult = response.data;
              console.log(dataResult);
              if(dataResult.state == 1){
                this.getFreeData();
                this.$message.success('上传成功！');
              }else{
                this.$message.error(dataResult.data);
              }
            })
          }

        },

        connect:function(){
          let  serverUrl='ws://localhost:13528';
          if(typeof(WebSocket) === "undefined"){
            alert("您的浏览器不支持socket")
          }else{
            // 实例化socket
            this.socket = new WebSocket(serverUrl);
            // 监听socket连接
            this.socket.onopen = this.open;
            // 监听socket错误信息
            this.socket.onerror = this.error;
            // 监听socket消息
            this.socket.onmessage = this.getMessage;
          }
        },
        open: function () {
          console.log("socket连接成功");
          //this.getPrint();
        },
        error: function () {
          console.log("连接错误")
        },
        getMessage: function (obj) {
          console.log(obj.data);
          let data = JSON.parse(obj.data);
          if (data.cmd == "getPrinters") {
            this.printerList = data.printers;
            this.printName = data.defaultPrinter;
          }else if (data.cmd == "getPrinterConfig") {
            alert(obj.data);
          }
          if (data.previewImage) {
            this.imgUrl = data.previewImage;
            this.showPreview=true;
          }
          //
          this.msg =  JSON.stringify(data);
          //let res = '{"cmd":"notifyTaskResult","requestID":"1662539327620","status":"completeSuccess","printer":"HPRT N41","taskId":"ZD1662539327620_TASK_0","spendTime":{"rendering":2665,"total":3189,"downloading":464,"pending":60},"docs":{"0":{"cmd":"notifyDocResult","requestID":"1662539327620","status":"printed","printer":"HPRT N41","taskId":"ZD1662539327620_TASK_0","code":0,"detail":"success","spendTime":{"total":2911,"downloading":348,"pending":55,"rendering":2508}} }}'
          //data = JSON.parse(res);
          if(data.status != null){
            if(data.status.toLowerCase().indexOf("success") == -1 ){
              this.showMsg = true;
            }
          }
          if(data.taskStatus != null){
            if (data.taskStatus == "failed") {
              this.showMsg = true;
            }
          }
          // if((data.status != 'success')||((data.taskStatus == 'failed'))){
          //   this.$alert(msg, '提示', {
          //     confirmButtonText: '确定',
          //   })
          // }
        },
        send: function () {
          this.socket.send(params)
        },
        close: function () {
          console.log("socket已经关闭")
        },
        getRequestObject: function (cmd) {
          let request = new Object();
          let time = new Date().getTime();
          request.requestID=time.toString();
          request.version="1.0";
          request.cmd=cmd;
          return request;
        },
        //打印快递单，先去后台取号，取号成功后，执行打印
        getPrintTids:function (status) {
          //看有没有添加用户模板，
          if(this.kdmbs.length == 0){
            this.$message.error("您还没有添加快递单模板，请先添加模板！");
            return;
          }
          //模板数据是否齐全
          for(let i=0;i<this.kdmbs.length;i++){
            if(this.kdmbs[i].id ==  this.kdmb){
              if((this.kdmbs[i].branchName == null)||(this.kdmbs[i].branchName == '') ){
                this.$message.error("您还没有电子面单网点信息，请在打印模板里设置网点信息！");
                return;
              }
              if(this.kdmbs[i].contactId == null){
                this.$message.error("您还没有设置发货地址，请在打印模板里设置发货地址！");
                return;
              }
            }
          }
          if(status == ''){
            status =  this.printStatus;
          }
          let tids='';
          const selectData = this.$refs.multipleTable.selection;
          if(selectData.length == 0){
            this.$message.error("您没有勾选任何订单，请选择订单");
            return;
          }
          console.log(selectData);
          for(let i=0;i<selectData.length;i++){
            //含有隐藏信息的订单不能取号
            if((selectData[i].mobile.indexOf('*') >=0 ) && (selectData[i].oaid == null))
              continue;

            tids = tids + selectData[i].tid+ ':' + selectData[i].serialNo +  ';';

            //预览时只显示一个订单
            if((status == "preview")&&(i == 0))
              break;
          }
          //去掉最后一个字符
          tids = tids.slice(0, tids.length-1);
          console.log('tids ' + tids);
          if(tids.length > 0)
            this.getWaybills(tids, status);
          else
            this.$message.error("省份不能为空,手机号中不能含有星号， 请检查！")
        },

        //去后台取单号，取打印数据
        getWaybills:function (tids, status) {
          let trades = [];
          let param={
            nick: storage.get('nick'),
            //快递模板
            tempId: this.kdmb,
            tids: tids,
            printStatus: status,
            channel:'OTHERS',
            sfProduct: this.sfProduct,
          }
          $api.post("cn/getWaybill", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if (dataResult.state == 1 && dataResult.message == "ok"){
              let packs = dataResult.data;
              console.log(packs);
              const selectData = this.$refs.multipleTable.selection;
              let msg = '';
              for (let i = 0; i < packs.length; i++) {
                let info = packs[i].info;
                if((info != null)&&(info.length>0))
                  msg =  msg + selectData[i].name + "：" + info+'\r\n';
              }
              console.log('msg:' + msg);

              //打单
              if(status == 'preview'){
                this.print(packs, 'preview', trades);
              }else  if((status == 'print') ||(status == 'rePrint')){
                this.print(packs, 'print', trades);
              }else if(status == 'rePrint'){
                this.$message.success('重打快递单成功！');
              }else if(status == 'cancel'){
                if(msg.length == 0)
                  this.$message.success('取消面单号成功！');
                else{
                  this.$message.error(msg);
                }
              }else if(status == 'sendGoods') {
                if (msg.length == 0)
                  this.$message.success('发货成功！');
                else {
                  this.$message.error(msg);
                }
              }
              this.getFreeData();
            }else{
              this.$message.error(dataResult.data.message);
            }
          })
        },
        //取号后，数据发送到打印机打印面单单
        print:function (wayBills, value,trades) {
          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID = 'ZD' + request.requestID + "_TASK_0";
          if (value == "preview") {
            //预览时用默认打印机预览
            request.task.printer = '';
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
            request.task.printer = this.printer;
            //为了打印测试
            let admin = storage.get('admin');
            if(admin == 'meyau'){
              request.task.printer = '';
            }
          }

          let documents = new Array();

          console.log(wayBills);

          //要打印的订单数据
          const selectData = this.$refs.multipleTable.selection;
          //const selectData = trades ;
          for (let i = 0; i < selectData.length; i++) {
            //如果面单号为空，说明取号失败，不进行打印
            if (wayBills[i].waybillCode == null) {
              this.$message.error('取号失败：'+wayBills[i].info);
              continue;
            }
            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            //电子面单
            let content = JSON.parse(wayBills[i].printData);
            console.log(content.templateURL);
            contents.push(content);
            //自定义区
            let tids ='';
            let skuField = '';
            let outerField = '';
            let num = 0;

                skuField = skuField + selectData[i].properties + '(' + selectData[i].num + ')件 ' + '\r\n';
                outerField = outerField + selectData[i].properties + '(' + selectData[i].num + ')件 ' + '\r\n';
                num = num + parseInt(selectData[i].num);
                if(tids.indexOf(selectData[i].tid)<0)
                  tids = tids + selectData[i].tid;

            let area = new Object();
            //area.templateURL = 'http://cloudprint.cainiao.com/template/standard/489107/5';
            let nick = storage.get('nick');
            let tempId = this.kdmb;
            area.templateURL = 'http://ss.zdinfo.top:8081/cn/custom/nick/ID'  + tempId;
            //本地测试
            //area.templateURL = 'http://localhost:8082/cn/custom/nick/ID'  + tempId;
            let data = new Object();
            //data.skuPropertiesName = "黑色 XL （120-130） 1件";
            data.skuNumTotal = '共【' + num + '】件\r\n' + skuField;
            data.outerNumTotal = '共【' + num + '】件\r\n' + outerField;
            data.totalNum = '1';
            data.tid=tids;
            data.buyerNick= '';
            data.sellerMemo = selectData[i].memo;
            area.data = data;
            contents.push(area);

            doc.contents = contents;
            documents.push(doc);
            //if (value == "preview")
            //break;
          }
          if (documents.length > 0) {
            request.task.documents = documents;
            console.log(JSON.stringify(request))
            this.socket.send(JSON.stringify(request));
          }else{
            console.log('无打印数据。')
          }
        },
        //根据选项，获取选中的列表
        getCity(){
          //https://blog.csdn.net/qq_40146638/article/details/113244100
          let province = '';
          let city='';
          let country = '';
          let cityList = this.$refs['cascader'].getCheckedNodes()
          console.log(cityList);
          const list = cityList.map(item => {
            return item.value
          })
          // 首先将全部的code拿到整合成一个数组
          const selectCityList = [] // 整合(拼装后)的数组
          cityList.forEach(item => {
            const proCode = item.value.toString().substr(2)
            const cityCode = item.value.toString().substr(4, 2)
            // 如果当前项的后四位为0000表示它是一个省份直接添加进新数组中
            if (proCode == '0000') {
              // console.log('选择的是省份')
              selectCityList.push(item.value)
              province +=  item.label + ',';
            } else if (cityCode == '00') {
              const code = (item.value.toString().substr(0, 2) + '0000')
              // 如果是城市的话, 则需要判断这个城市所属的省份有没有在数组里面,
              // 有当前城市的省份 ==> 不添加进数据
              // 没有省份 ==> 添加进数据
              if (!list.includes(code)) {
                selectCityList.push(item.value)
                city += item.label + ',';
              }
              // console.log('选择的是城市')
            } else {
              const code = (item.value.toString().substr(0, 4) + '00')
              const proCode = (item.value.toString().substr(0, 2) + '0000')
              // 如果是区县的话, 则需要判断这个城市所属的省份和城市有没有在数组里面
              // 有当前区县的省份或者城市 ==> 不添加进数据
              // 没有省份和城市 ==> 添加进数据
              if (!list.includes(code) && !list.includes(proCode)) {
                selectCityList.push(item.value)
                country +=  item.parent.parent.label + item.label  + ',';
              }
              // console.log('默认选择的是区县')
            }
          })
           console.log(selectCityList, '选中列表')
          console.log(province)
          console.log(city)
          console.log(country)
          return selectCityList.length ? selectCityList : []
        },
        //根据列表还原用户的选项
        //把代码转化为字符
        handleChange(code) {
          console.log(this.code);
          //遍历省
          for(let i=0;i<this.cities.length;i++){
            let p=this.cities[i]
            if(p.value == code[0]){
              console.log(p.label)
              this.province = p.label;
              //市
              for(let j=0; j<p.children.length;j++) {
                let c = p.children[j]
                if(c.value == code[1]){
                  console.log(c.label)
                  this.city = c.label;
                  for(let k=0; k<c.children.length;k++){
                    let a=c.children[k];
                    if(a.value == code[2]){
                      console.log(a.label)
                      this.country = a.label;
                      break;
                    }
                  }
                  break;
                }
              }
              break;
            }
          }
        },
        //字符转为代码
        enCode(v){
          let s =v.split(' ');
          for(let i=0;i<this.cities.length;i++){
            let p=this.cities[i]
            if(p.label == s[0]){
              console.log(p.label)
              this.code[0] = p.value;
              //市
              for(let j=0; j<p.children.length;j++) {
                let c = p.children[j]
                if(c.label == s[1]){
                  console.log(c.label)
                  this.code[1] = c.value;
                  for(let k=0; k<c.children.length;k++){
                    let a=c.children[k];
                    if(a.label == s[2]){
                      console.log(a.label)
                      this.code[2] = a.value;
                      break;
                    }
                  }
                  break;
                }
              }
              break;
            }
          }
          console.log(this.code);
        }

      },
      mounted(){
        this.init();
        this.connect();
        this.getTemp();
        this.getFreeData();
      }

    }
</script>

<style scoped>
  .label{
    display:inline-block;
    width: 100px;
    text-align: right;
  }
  .mltlabel{
    line-height: 50px;
    display:inline-block;
    width: 100px;
    text-align: right;
  }
  .must{
    color: red;
    font-size: 16px;
    margin-right: 2px;
  }
  .el-checkbox__label {
    display: inline-block;
    padding-left: 0px;
    line-height: 19px;
    font-size: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/print/Free.vue